import auditionList from "./auditionList.vue";
export default auditionList;
